// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"67fbf81c","122":"32b9138c","360":"74325315","455":"4d89a86d","696":"e4a2d288","918":"40a9db71"}[chunkId] + ".css";
};